import React from "react";

export default function Percentage({ value, base }) {
  const percentage = Math.round((value / base) * 100);
  if (Number.isNaN(percentage)) return null;
  return <>{percentage}%</>;
}
